import { render, staticRenderFns } from "./TablaCamposEditados.vue?vue&type=template&id=c5de3298&"
import script from "./TablaCamposEditados.vue?vue&type=script&lang=js&"
export * from "./TablaCamposEditados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports